import { useEffect, useState } from "react";
import { NavLink, Outlet, useLocation } from "react-router-dom";
import { FiGithub, FiLinkedin, FiMail, FiMoon, FiSun } from "react-icons/fi";
import { socials } from "../data/profile";
import "../styles/Layout.css";

const socialIcons = {
  github: FiGithub,
  linkedin: FiLinkedin,
  mail: FiMail,
};

const navItems = [
  { to: "/", label: "Home", end: true },
  { to: "/about", label: "About" },
  { to: "/skills", label: "Skills" },
  { to: "/resume", label: "Resume" },
  { to: "/writing", label: "Writing" },
];

/** Persisted theme choice; falls back to the system preference on first visit. */
const useTheme = () => {
  const [theme, setTheme] = useState(
    () => localStorage.getItem("aj-theme") || "dark"
  );

  useEffect(() => {
    document.documentElement.setAttribute("data-theme", theme);
    localStorage.setItem("aj-theme", theme);
  }, [theme]);

  return [theme, () => setTheme((t) => (t === "dark" ? "light" : "dark"))];
};

const Layout = () => {
  const [theme, toggleTheme] = useTheme();
  const { pathname } = useLocation();

  // Routed navigation should land at the top of the new page, not mid-scroll.
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return (
    <div className="shell">
      <header className="nav">
        <div className="nav__inner">
          <NavLink to="/" className="nav__brand" aria-label="Home">
            <span className="nav__mark gradient-accent">AJ</span>
          </NavLink>

          <nav className="nav__links" aria-label="Primary">
            {navItems.map(({ to, label, end }) => (
              <NavLink
                key={to}
                to={to}
                end={end}
                className={({ isActive }) =>
                  `nav__link${isActive ? " nav__link--active" : ""}`
                }
              >
                {label}
              </NavLink>
            ))}
          </nav>

          <button
            type="button"
            className="nav__theme"
            onClick={toggleTheme}
            aria-label={`Switch to ${theme === "dark" ? "light" : "dark"} mode`}
          >
            {theme === "dark" ? <FiSun /> : <FiMoon />}
          </button>
        </div>
      </header>

      <main>
        <Outlet />
      </main>

      <footer className="footer">
        <div className="footer__inner">
          <span className="footer__note">
            © {new Date().getFullYear()} Akhil Jayendran
          </span>
          <div className="footer__socials">
            {socials.map(({ label, href, icon }) => {
              const Icon = socialIcons[icon];
              return (
                <a
                  key={label}
                  href={href}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={label}
                  className="footer__social"
                >
                  <Icon />
                </a>
              );
            })}
          </div>
        </div>
      </footer>
    </div>
  );
};

export default Layout;
